import { useNavigate } from '@tanstack/react-router';
import type { VisualizationType } from '@tempo-io/roadmap-dto';
import { Button } from '@tempo-io/sui-button';
import { Effectors } from '@tempo-io/sui-icons';
import { useTranslation } from 'react-i18next';
import { useOrgName } from '@/lib/hooks/common/useOrgName';

type NoItemsKey =
  | 'views.swimlane.emptyStates.noItems.description'
  | 'views.timeline.emptyStates.noItems.description'
  | 'views.table.emptyStates.noItems.description';

export const VisualizationNoItemsState = ({
  visualizationType,
}: {
  visualizationType: VisualizationType;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const org = useOrgName();

  let noItemsKey: NoItemsKey | undefined;
  if (visualizationType === 'swimlane') {
    noItemsKey = 'views.swimlane.emptyStates.noItems.description';
  } else if (visualizationType === 'timeline') {
    noItemsKey = 'views.timeline.emptyStates.noItems.description';
  } else if (visualizationType === 'table') {
    noItemsKey = 'views.table.emptyStates.noItems.description';
  }

  return (
    <div className="flex flex-col w-full items-center gap-4 py-8">
      <div className="text-xl font-bold">{t('views.visualization.emptyStates.noItems.title')}</div>
      {noItemsKey && <div className="mb-2 text-text-neutral-secondary">{t(noItemsKey)}</div>}
      <Button
        className="my-2 w-60"
        onClick={() => navigate({ to: '/org/$org/settings/work-integrations', params: { org } })}
      >
        <Effectors /> {t('itemTable.emptyState.button')}
      </Button>
      <div className="mt-4 text-base">
        {t('itemTable.emptyState.help')}{' '}
        <a
          href="https://help.tempo.io"
          target="_blank"
          rel="noopener noreferrer"
          className="text-text-info"
        >
          {t('itemTable.emptyState.guide')}
        </a>{' '}
        {t('itemTable.emptyState.helpSuffix')}
      </div>
    </div>
  );
};
